import React from "react";
import { FixedRangeInterpolatedCaptureProperty } from "../../../Model/CaptureProfile";
import DefaultImagingSettingTextBox from "./DefaultImagingSettingTextBox";
import "./FixedRangeOptions.css"
const IMAGING_Z_MAX = "imagingZmax";
const IMAGING_Z_MIN = "imagingZmin";
const MAX_FOCUS_LEVELS = "maxFocusLevels";

type Props = {
  style: React.CSSProperties;
  fixedRangeInterpolatedCaptureProperty: FixedRangeInterpolatedCaptureProperty;
  onChange: (fixedRangeInterpolatedCaptureProperty: FixedRangeInterpolatedCaptureProperty) => void;
  onErrorOccur: (key: string) => void;
  onErrorCleared: (key: string) => void;
};

export default function FixedRangeOptions({ style, fixedRangeInterpolatedCaptureProperty, onChange, onErrorOccur, onErrorCleared }: Props) {
  return (
    <div
      className="fixed-range-interpolated"
      style={{
        ...style,
      }}
    >
      <DefaultImagingSettingTextBox
        value={fixedRangeInterpolatedCaptureProperty.imagingZmin}
        onChange={(name, value) => onChange({ ...fixedRangeInterpolatedCaptureProperty, imagingZmin: value })}
        label="Start Z"
        name={IMAGING_Z_MIN}
        unit="mm"
        style={{
          gridArea: IMAGING_Z_MIN,
        }}
        disabled={false}
        isInteger={true}
        min={-50}
        max={50}
        onErrorOccur={(name) => onErrorOccur(name)}
        onErrorCleared={(name) => onErrorCleared(name)}
      />

      <DefaultImagingSettingTextBox
        value={fixedRangeInterpolatedCaptureProperty.imagingZmax}
        onChange={(name, value) => onChange({ ...fixedRangeInterpolatedCaptureProperty, imagingZmax: value })}
        label="Stop Z"
        name={IMAGING_Z_MAX}
        unit="mm"
        style={{
          gridArea: IMAGING_Z_MAX,
        }}
        disabled={false}
        isInteger={true}
        min={-50}
        max={50}
        onErrorOccur={(name) => onErrorOccur(name)}
        onErrorCleared={(name) => onErrorCleared(name)}
      />

      <DefaultImagingSettingTextBox
        value={fixedRangeInterpolatedCaptureProperty.maxFocusLevels}
        onChange={(name, value) => onChange({ ...fixedRangeInterpolatedCaptureProperty, maxFocusLevels: value })}
        label="Focus Levels"
        name={MAX_FOCUS_LEVELS}
        unit=""
        style={{
          gridArea: MAX_FOCUS_LEVELS,
        }}
        disabled={false}
        isInteger={true}
        min={1}
        max={50}
        onErrorOccur={(name) => onErrorOccur(name)}
        onErrorCleared={(name) => onErrorCleared(name)}
      />
    </div>
  );
}
